export default {"src":"/_next/static/media/BSC.79b78357.svg","height":24,"width":137,"blurWidth":0,"blurHeight":0};